module.exports = __webpack_public_path__ + "img/phone.7b3fd07d.svg";